import Whitewash from '../../../../components/editable-cell/form-items/whitewash'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'

export const whitewashColumn: ShipmentColumn = {
    key: 'whitewash',
    dataIndex: 'whitewash',
    title: <RotatedTitle>Белила</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Whitewash />,
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм')
    }) as any,
}
